export default __webpack_public_path__ + "static/media/wildlife09.12452249.png";